module.exports = __webpack_public_path__ + "static/img/light-task.9f7dc5eb.png";